import React from "react";
import { Loader } from "../../lib/ui/components";
import { useParams } from "react-router-dom";
import _ from "lodash";
import "./product-catalogue-print.style.scss";
import {
  handleRenderImageSrc,
  primaryDetailsOrder,
  productDataMap,
  technicalInformationRows,
  unitMap,
} from "../product-catalogue-print-mth/product-catalogue-print.constant";
import { useProduct } from "../../lib/hooks/useProduct";
import headerBanner from "../../assets/images/catalogue/arman-cnc-header.png";
import footerBanner from "../../assets/images/catalogue/arman-cnc-footer.png";

export const ProductCataloguePrintNewComponent = () => {
  const { productId } = useParams<{ productId: string }>();
  const { product, isLoading, error } = useProduct(productId);

  if (isLoading) return <Loader visible />;
  if (error) return <div>خطا در بارگذاری محصول.</div>;
  if (!product) return null;

  const productTitle = product.name;
  // const productSku = product.sku || product.id;

  const customKeyMap: Record<string, string> = {
    product_name: product.name,
    dimensions:
      product.dimensions.length ||
      product.dimensions.width ||
      product.dimensions.height
        ? `${product.dimensions.length} * ${product.dimensions.width} * ${product.dimensions.height}`
        : "",
  };

  function getDataFromProduct(key: string): string {
    if (key.startsWith("custom:")) {
      return customKeyMap[key.replace("custom:", "")] || "-";
    }
    const productData = product;
    const value =
      productData.metaDataObj[key]?.value || (productData as any)[key] || "-";

    if (Array.isArray(value)) {
      return value[0] || "-";
    }
    return String(value);
  }

  return (
    <div className="printable-area">
      <div className="print-background-fa"></div>
      <div className="page-container-product-catalogue-fa">
        <div className="page-header-print">
          <img
            src={headerBanner}
            alt="Company Banner"
            className="header-banner"
          />
        </div>
        <div className="page-footer-print">
          <img
            src={footerBanner}
            alt="Company Footer"
            className="footer-banner"
          />
        </div>
        <table className="print-layout-table">
          <thead>
            <tr>
              <td>
                <div className="header-spacer"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="main-content">
                  <div className="header-text">
                    <h1 id="category-title">{productTitle}</h1>
                    {/* <h6 id="sku">شناسه آرمان: {productSku}</h6> */}
                  </div>
                  <div className="large-image-container">
                    {handleRenderImageSrc(product.images, 1)}
                  </div>
                  <div className="primary-details">
                    {primaryDetailsOrder.map((key) => {
                      const dataValue = getDataFromProduct(key);
                      if (dataValue === "-") return null;
                      const label =
                        productDataMap[key as keyof typeof productDataMap]
                          ?.translationFa ?? _.startCase(key);
                      return (
                        <span key={key}>
                          {label}: {dataValue}
                        </span>
                      );
                    })}
                    <span>موقعیت: - </span>
                  </div>
                  <div className="tech-info">
                    <div className="tech-info-data">
                      <h2 className="header force-break">اطلاعات فنی:</h2>
                      <table className="spec-table">
                        <thead>
                          <tr>
                            <th scope="col">مشخصات</th>
                            <th scope="col">واحد</th>
                            <th scope="col">مقدار</th>
                          </tr>
                        </thead>
                        <tbody>
                          {technicalInformationRows.map((rawKey) => {
                            const key = rawKey.replace("custom:", "");
                            const value = getDataFromProduct(rawKey);
                            if (value === "-") return null;
                            return (
                              <tr key={key}>
                                <td>
                                  {productDataMap[
                                    key as keyof typeof productDataMap
                                  ]?.translationFa ?? _.startCase(key)}
                                </td>
                                <td>
                                  {unitMap[key as keyof typeof unitMap] ?? "-"}
                                </td>
                                <td>{value}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="image-column force-break">
                      {handleRenderImageSrc(product.images, 2)}
                      {handleRenderImageSrc(product.images, 3)}
                    </div>
                  </div>
                  {/* <div>
                    <h2 className="delivery-header">تحویل</h2>
                    <p>شرایط تحویل: EX work as is where is (UK)</p>
                    <p>
                      تحویل: دستگاه در یک کانتینر فلت رک ۲۰ فوت + یک کانتینر
                      استاندارد ۴۰ فوت حمل خواهد شد
                    </p>
                  </div> */}
                  <div>
                    <h2 className="delivery-header force-break">
                      تصاویر بیشتر:
                    </h2>
                    <div className="image-gallery">
                      {product.images.slice(3).map((image, index) => (
                        <img
                          key={index}
                          src={image.src}
                          alt="catalogue"
                          className="catalogue-img"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div className="footer-spacer"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
